<template lang="html">
    <form class="form3" id="onboarding">
        <div class="formGroup">
            <label>Date of birth</label>
            <input type="text" v-model="form.dob" />
            <has-error :form="form" field="dob" />
        </div>

        <div class="formGroup">
            <label>Address Line 1</label>
            <input type="text" v-model="form.address_line1" />
            <has-error :form="form" field="address_line1" />
        </div>

        <div class="formGroup">
            <label>Address Line 2</label>
            <input type="text" v-model="form.address_line2" />
            <has-error :form="form" field="address_line2" />
        </div>

        <div class="formGroup">
            <label>City</label>
            <input type="text" v-model="form.address_city" />
            <has-error :form="form" field="address_city" />
        </div>

        <div class="formGroup">
            <label>Post code</label>
            <input type="text" v-model="form.address_postcode" />
            <has-error :form="form" field="address_postcode" />
        </div>

        <div class="formGroup">
            <label>County</label>
            <select v-model="form.address_county">
                <option></option>
                <option>Bedfordshire</option>
                <option>Berkshire</option>
                <option>Bristol</option>
                <option>Buckinghamshire</option>
                <option>Cambridgeshire</option>
                <option>Cheshire</option>
                <option>City of London</option>
                <option>Cornwall</option>
                <option>Cumbria</option>
                <option>Derbyshire</option>
                <option>Devon</option>
                <option>Dorset</option>
                <option>Durham</option>
                <option>East Riding of Yorkshire</option>
                <option>East Sussex</option>
                <option>Essex</option>
                <option>Gloucestershire</option>
                <option>Greater London</option>
                <option>Greater Manchester</option>
                <option>Hampshire</option>
                <option>Herefordshire</option>
                <option>Hertfordshire</option>
                <option>Isle of Wight</option>
                <option>Kent</option>
                <option>Lancashire</option>
                <option>Leicestershire</option>
                <option>Lincolnshire</option>
                <option>Merseyside</option>
                <option>Norfolk</option>
                <option>North Yorkshire</option>
                <option>Northamptonshire</option>
                <option>Northumberland</option>
                <option>Nottinghamshire</option>
                <option>Oxfordshire</option>
                <option>Rutland</option>
                <option>Shropshire</option>
                <option>Somerset</option>
                <option>South Yorkshire</option>
                <option>Staffordshire</option>
                <option>Suffolk</option>
                <option>Surrey</option>
                <option>Tyne and Wear</option>
                <option>Warwickshire</option>
                <option>West Midlands</option>
                <option>West Sussex</option>
                <option>West Yorkshire</option>
                <option>Wiltshire</option>
                <option>Worcestershire</option>
            </select>
            <has-error :form="form" field="address_county" />
        </div>

        <div class="formGroup">
            <label v-if="user.type == 'player'"
                >So that we can take payment for your lesson credits, please enter your debit/credit
                card number</label
            >

            <!--  <label v-else>Please enter the card number that we will send payments to for your lessons</label>
            <div class="card" ref="card"></div>-->
            <label for="">Account holder name</label>
            <input type="text" v-model="form.account_name" />
            <label for="">Sort Code</label>
            <input type="text" v-model="form.sortcode" maxlength="6" />
            <label for="">Account number</label>
            <input type="text" v-model="form.accountno" maxlength="8" />
            <has-error :form="form" field="token" />
        </div>

        <div class="formGroup">
            <label
                >So that we can validate your identity, please upload an identifying document either
                a passport or driving license. PLease note the uploaded images must be in colour,
                smaller than 8000px x 8000px in JPG, PNG or PDF format and less than 10MB in
                size</label
            >

            <label class="button dark">
                <input type="file" name="" value="" /> Front image of ID
            </label>

            <label class="button dark">
                <input type="file" name="" value="" /> Back image of ID
            </label>
        </div>

        <div class="formGroup">
            <label>
                <input type="checkbox" v-model="form.tos" /> I accept Lesson Pro Terms of service
            </label>
            <has-error :form="form" field="tos" />
        </div>

        <div class="formGroup">
            <button @click.prevent="addCard" class="button dark" type="button" name="button">
                Add payment details
            </button>
        </div>
    </form>
</template>

<script>
import { Form, HasError } from "vform";
export default {
    name: "onboarding",
    components: { HasError },
    mounted() {
        //var elements = this.stripe.elements()
        //this.card = elements.create('card');
        //this.card.mount(this.$refs.card);
    },
    data() {
        return {
            //stripe:  window.Stripe(process.env.VUE_APP_STRIPE_KEY),
            //card: undefined,
            form: new Form({
                dob: "19-02-1983",
                address_line1: "12 Maple Gardens",
                address_line2: "Headingley",
                address_city: "Leeds",
                address_postcode: "LS6 1FL",
                address_county: "West Yorkshire",
                account_name: "",
                sortcode: "",
                accountno: "",
                tos: true,
            }),
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        addCard: function () {
            /*
        this.stripe.createToken(this.card,{ 'currency': 'gbp' }).then((result)=>{
          if (result.error) {
            self.hasCardErrors = true;
            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
            return;
          }
        })
        */

            //this.form.token = result.token.id
            this.form.post("/stripe/add").then((response) => {
                console.log(response);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#onboarding {
    padding: 20px;
    background: $green_1;
    min-height: 100vh;
    .card {
        width: 100%;
        background: #e7efeb;
        border: 0px;
        padding: 20px;
        border-radius: 12px;
        font-size: 1rem;
        font-family: canada-type-gibson, sans-serif;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        color: #267962;
        max-width: 100%;
        min-width: 100%;
    }
}
</style>
